var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUsersAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_282_2687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_282_2687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6 7.2001C15.6 9.18832 13.9883 10.8001 12 10.8001C10.0118 10.8001 8.4 9.18832 8.4 7.2001C8.4 5.21188 10.0118 3.6001 12 3.6001C13.9883 3.6001 15.6 5.21188 15.6 7.2001ZM21.6 9.6001C21.6 10.9256 20.5255 12.0001 19.2 12.0001C17.8745 12.0001 16.8 10.9256 16.8 9.6001C16.8 8.27461 17.8745 7.2001 19.2 7.2001C20.5255 7.2001 21.6 8.27461 21.6 9.6001ZM16.8 18.0001C16.8 15.3491 14.6509 13.2001 12 13.2001C9.34903 13.2001 7.2 15.3491 7.2 18.0001V21.6001H16.8V18.0001ZM7.2 9.6001C7.2 10.9256 6.12548 12.0001 4.8 12.0001C3.47451 12.0001 2.4 10.9256 2.4 9.6001C2.4 8.27461 3.47451 7.2001 4.8 7.2001C6.12548 7.2001 7.2 8.27461 7.2 9.6001ZM19.2 21.6001V18.0001C19.2 16.7352 18.8738 15.5463 18.3008 14.5133C18.5882 14.4394 18.8896 14.4001 19.2 14.4001C21.1883 14.4001 22.8 16.0118 22.8 18.0001V21.6001H19.2ZM5.69912 14.5133C5.12623 15.5463 4.8 16.7352 4.8 18.0001V21.6001H1.2V18.0001C1.2 16.0118 2.81178 14.4001 4.8 14.4001C5.11045 14.4001 5.41173 14.4394 5.69912 14.5133Z",
    fill: "#FFB829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUsersAlt);
export default __webpack_public_path__ + "static/media/u_users-alt.4f2c0c3758b951e3ced425a1e70680ef.svg";
export { ForwardRef as ReactComponent };